import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTablet = () => {
  return (
    <g>
      <path d="m2.05 0 11.901.017c.541 0 .986.41 1.043.936l.006.114V14.95c0 .541-.41.987-.936 1.044L13.95 16H2.05a1.05 1.05 0 0 1-1.044-.936L1 14.95V1.05c0-.54.41-.986.936-1.043L2.05 0zM13.5 12h-11v2.5h11V12zm-4.75.5a.75.75 0 1 1 0 1.5h-1.5a.75.75 0 1 1 0-1.5h1.5zM13.5 4h-11v6.5h11V4zM2.5 1.5v.998h11v-.983l-11-.015z" />
    </g>
  );
};

export default withIcon(IconTablet);
